var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBusinessCashFlow40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BusinessCashflow40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-Honeycomb-Foundation/pictogram/ExtraSmall./Insurance40-Copy-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle",
    fill: "#4F4C4D",
    points: "0 17 21 17 21 18 0 18"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    x: 16.5,
    y: 0.5,
    width: 5,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 8.5,
    y: 5.5,
    width: 5,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Bar",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    x: 0.5,
    y: 11.5,
    width: 5,
    height: 6
  })), /*#__PURE__*/React.createElement("line", {
    x1: 13.6041667,
    y1: 19.1358333,
    x2: 27.0208333,
    y2: 9.8025,
    id: "Line-2",
    stroke: "#4F4C4D",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,9.5 C26.5,8.67105263 27.1710526,8 28,8 C28.8289473,8 29.5,8.67105263 29.5,9.5 C29.5,10.3289474 28.8289473,11 28,11 C27.1710526,11 26.5,10.3289474 26.5,9.5 Z",
    id: "Point-4",
    stroke: "#4F4C4D",
    fill: "#FFCC00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5,14.5 C18.5,13.6710526 19.1710526,13 20,13 C20.8289473,13 21.5,13.6710526 21.5,14.5 C21.5,15.3289474 20.8289473,16 20,16 C19.1710526,16 18.5,15.3289474 18.5,14.5 Z",
    id: "Point-2",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,22 C11.1710526,22 10.5,21.3289474 10.5,20.5 C10.5,19.6710527 11.1710526,19 12,19 C12.8289474,19 13.5,19.6710527 13.5,20.5 C13.5,21.3289474 12.8289474,22 12,22",
    id: "Point-1",
    stroke: "#4F4C4D",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBusinessCashFlow40);
export default __webpack_public_path__ + "static/media/pictogramBusinessCashFlow40.6b5453f96606c70e76c6857438d8922b.svg";
export { ForwardRef as ReactComponent };